import React, { useState } from "react";
import { saveAsDraft } from "../../Components/Dashboard/RoofSelection/roofFunction";
import "./sideNav.css";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
// import ProgressBar from "react-bootstrap/ProgressBar";
import {
  ManageAccounts,
  AdminPanelSettings,
  SupervisorAccount,
  SupervisedUserCircle,
  SettingsSharp,
  Announcement,
  PermMedia,
  CloudUpload,
  PersonAdd,
} from "@mui/icons-material";
import { ProjectApi } from "../../apis";
import { Tooltip } from "@mui/material";

function SideNav({ active }) {
  const ProjectRouter = ProjectApi();
  const user = useSelector((state) => state?.conUser?.user);
  // const [showFeedback, setShowFeedback] = useState(false);
  // const [feedbackInfo, setFeedbackInfo] = useState({
  //   file: "",
  //   description: "",
  //   title: "",
  // });
  const [draftLoader, setDraftLoader] = useState(false);
  const [show, setShow] = useState(false);
  const conUser = useSelector((state) => state?.conUser);
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  // const [thumbnail, setThumbnail] = useState("");
  // const [uploadProgress] = useState(0);
  // const [fileType, setFileType] = useState("");
  // const pathName = window.location.pathname;

  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const fileSizeInMegabytes = file.size / (1024 * 1024); // Convert bytes to megabytes
  //     if (fileSizeInMegabytes <= 50) {
  //       setFileType(file.type.split("/")[0]);
  //       setThumbnail(URL.createObjectURL(file));
  //       setFeedbackInfo({
  //         ...feedbackInfo,
  //         file: file,
  //       });
  //     } else {
  //       alert("File size exceeds 50MB. Please choose a smaller file.");
  //       e.target.value = ""; // Clear the file input
  //     }
  //   }
  // };

  const [showLogout, setShowLogout] = useState(false);
  const handleClose = () => {
    setShow(false);
    setShowLogout(false);
  };
  const navigate = useNavigate();

  const logOut = () => {
    sessionStorage.clear();
    navigate("/SignIn");
  };

  // const myProject = (value) => {
  //   if (
  //     pathName === "/createProject" ||
  //     pathName === "/analytics" ||
  //     pathName === "/design" ||
  //     pathName === "/electrical" ||
  //     pathName === "/financial" ||
  //     pathName === "/summary"
  //   ) {
  //     setShow(true);
  //   } else {
  //     navigate(value);
  //   }
  // };

  const noProjectSave = () => {
    const RemoveItem = [
      "projects",
      "cid",
      "customerName",
      "projectId",
      "roofPolygons",
      "structureItem",
      "myData",
      "imageSrc",
      "ImageSrc",
    ];
    RemoveItem.forEach((key) => {
      sessionStorage.removeItem(key);
    });
    navigate("/Dashboard");
  };

  return (
    <>
      <div className="nav">
        {/* new icons add */}
        {conUser?.roles?.includes("SUPER") ? (
          <>
            <Link
              to="/admins"
              className={`${active === "admins" ? "active" : ""}`}
            >
              <Tooltip
                title="Admins"
                arrow
                placement="right"
                classes={{
                  tooltip: "tooltip",
                  arrow: "tooltipArrow",
                }}
              >
                <SupervisorAccount />
              </Tooltip>
            </Link>
            <Link
              to="/salesAdmins"
              className={`${active === "SalesAdmins" ? "active" : ""}`}
            >
              <Tooltip
                title="Sales Admins"
                arrow
                placement="right"
                classes={{
                  tooltip: "tooltip",
                  arrow: "tooltipArrow",
                }}
              >
                <SupervisedUserCircle />
              </Tooltip>
            </Link>
            <Link
              to="/roles"
              className={`${active === "roles" ? "active" : ""}`}
            >
              <Tooltip
                title="Roles"
                arrow
                placement="right"
                classes={{
                  tooltip: "tooltip",
                  arrow: "tooltipArrow",
                }}
              >
                <AdminPanelSettings />
              </Tooltip>
            </Link>
            <Link
              to="/permissions"
              className={`${active === "Permissions" ? "active" : ""}`}
            >
              <Tooltip
                title="Permission"
                arrow
                placement="right"
                classes={{
                  tooltip: "tooltip",
                  arrow: "tooltipArrow",
                }}
              >
                <ManageAccounts />
              </Tooltip>
            </Link>
            <Link
              to="/media"
              className={`${active === "Media" ? "active" : ""}`}
            >
              <Tooltip
                title="Media"
                arrow
                placement="right"
                classes={{
                  tooltip: "tooltip",
                  arrow: "tooltipArrow",
                }}
              >
                <CloudUpload />
              </Tooltip>
            </Link>
            
          </>
        ) : null}

        {conUser?.roles?.some((role) =>
          ["DESIGNER", "CUSTOMER", "ADMIN"].includes(role)
        ) ? (
          <Link
            to="/dashboard"
            className={`${active === "Dashboard" ? "active" : ""}`}
          >
            <Tooltip
              title="Dashboard"
              arrow
              placement="right"
              classes={{
                tooltip: "tooltip",
                arrow: "tooltipArrow",
              }}
            >
              <PermMedia />
            </Tooltip>
          </Link>
        ) : null}

        {conUser?.roles?.includes("ADMIN") ? (
          <Link
            to="/designers"
            className={`${active === "Designers" ? "active" : ""}`}
          >
            <Tooltip
              title="Designers"
              arrow
              placement="right"
              classes={{
                tooltip: "tooltip",
                arrow: "tooltipArrow",
              }}
            >
              <SupervisorAccount />
            </Tooltip>
          </Link>
        ) : null}

        {conUser?.roles?.includes("SALES_ADMIN") ? (
          <Link
            to="/customers"
            className={`${active === "Customers" ? "active" : ""}`}
          >
            <Tooltip
              title="Customers"
              arrow
              placement="right"
              classes={{
                tooltip: "tooltip",
                arrow: "tooltipArrow",
              }}
            >
              <SupervisorAccount />
            </Tooltip>
          </Link>
        ) : null}

        {conUser?.roles?.some((role) =>
          ["SUPER", "SALES_ADMIN"].includes(role)
        ) ? (
          <Link
            to="/requests"
            className={`${active === "Requests" ? "active" : ""}`}
          >
            <Tooltip
              title="Requests"
              arrow
              placement="right"
              classes={{
                tooltip: "tooltip",
                arrow: "tooltipArrow",
              }}
            >
              <PersonAdd />
            </Tooltip>
          </Link>
        ) : null}

        {conUser?.roles?.some((role) =>
          ["DESIGNER", "CUSTOMER", "ADMIN", "SALES_ADMIN"].includes(role)
        ) ? (
          <Link
            to="/settings"
            className={`${active === "Settings" ? "active" : ""}`}
          >
            <Tooltip
              title="Settings"
              arrow
              placement="right"
              classes={{
                tooltip: "tooltip",
                arrow: "tooltipArrow",
              }}
            >
              <SettingsSharp />
            </Tooltip>
          </Link>
        ) : null}

        {/* support button  */}

        <Tooltip
          title="Feedback"
          arrow
          placement="right"
          classes={{
            tooltip: "tooltip",
            arrow: "tooltipArrow",
          }}
        >
          <Announcement />
        </Tooltip>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="sideNavModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Save Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                ProjectRouter,
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="secondary" onClick={() => noProjectSave()}>
            Don't save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showLogout}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="sideNavModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => logOut()}>
            Logout
          </Button>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Feedback Modal */}
      {/* <Modal
        show={showFeedback}
        onHide={() => setShowFeedback(false)}
        backdrop="static"
        keyboard={false}
        centered
        className="featureModal"
      >
        <Modal.Body className="feature-show-model">
          <div>
            <div className="inputs">
              <h3 className="heading" style={{ marginBottom: "-10px" }}>
                Attachment
              </h3>
              <div
                className="logo"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div className="fileBox">
                  <input
                    id="img-upload"
                    placeholder="test"
                    type="file"
                    name="img"
                    aria-labelledby="Choose Attachment"
                    // accept="image/*, video/*"
                    onChange={
                      (e) => handleFileUpload(e)
                      // uploadTest(e)
                    }
                  />
                  <span>*Upload image or video file smaller than 50MB.</span>
                </div>
                {fileType === "video" && (
                  <>
                    <video
                      src={thumbnail}
                      // src={feedbackInfo.image ? feedbackInfo.image : ""}
                      alt="NoFeedbackImage"
                      style={{ width: "300px", maxHeight: "250px" }}
                    />
                    <ProgressBar
                      now={uploadProgress}
                      variant="warning"
                      animated
                      style={{ width: "300px" }}
                      striped
                      label={`${uploadProgress}%`}
                    />
                  </>
                )}
                {fileType === "image" && (
                  <>
                    <img
                      src={thumbnail}
                      // src={feedbackInfo.image ? feedbackInfo.image : ""}
                      alt="NoFeedbackImage"
                      style={{ width: "300px", maxHeight: "250px" }}
                    />
                    <ProgressBar
                      now={uploadProgress}
                      variant="warning"
                      animated
                      style={{ width: "300px" }}
                      striped
                      label={`${uploadProgress}%`}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="inputs">
              <h3
                className="heading"
                style={{ marginTop: "10px", marginBottom: "-10px" }}
              >
                Title
              </h3>
              <input
                type="text"
                className="inputField"
                name="description"
                value={feedbackInfo.title}
                // style={{ width: "100%", height: "100px" }}
                onChange={(e) =>
                  setFeedbackInfo({
                    ...feedbackInfo,
                    title: e.target.value,
                  })
                }
                placeholder="Feedback Title"
              />
            </div>
            <div className="inputs">
              <h3
                className="heading"
                style={{ marginTop: "10px", marginBottom: "-10px" }}
              >
                Description
              </h3>
              <textarea
                type="text"
                className="inputField"
                name="description"
                value={feedbackInfo.description}
                style={{ width: "100%", height: "100px" }}
                onChange={(e) =>
                  setFeedbackInfo({
                    ...feedbackInfo,
                    description: e.target.value,
                  })
                }
                placeholder="Describe your problem or suggestion in detail..."
              />
            </div>
          </div>

          <div className="button-pair">
            <button
              className="closeButton"
              onClick={() => setShowFeedback(false)}
            >
              Close
            </button>
            <button
              className="nextButton"
              // onClick={(e) => {
              //   submitFeedback(e);
              // }}
            >
              Submit Feedback
            </button>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default SideNav;
